module.exports = __webpack_public_path__ + "media/images/mic-icon-672c93823ea69bd8b05806f29b52ba87ad82a13e40a07236efacfcfd8206d4c5.png";